<template>
  <div class="wrapper wrapper-content">
    <div id="modal-order" class="modal fade" aria-hidden="true" ref="addOrder">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-body">
            <div class="col-lg-12"><h3 class="m-t-none m-b">Add Order</h3></div>
            <div class="row">
              <div class="col-lg-12">
                <div class="form-group">
                  <div class="row">
                    <div class="col-lg-3"><label for="remoteId">Id</label></div>
                    <div class="col-lg-9"><input type="text" name="remoteId" id="remoteId" v-model="add.remoteId"  ref="remoteId" class="col-lg-12" minlength="3"></div>
                  </div>
                  <div class="row">
                    <div class="col-lg-3"><label for="oUrls">Urls</label></div>
                    <div class="col-lg-9"><textarea name="urls" id="oUrls" v-model="add.urls" class="col-lg-12"  ref="urls" rows="20"></textarea></div>
                  </div>
                  <div class="row">
                    <div class="col-lg-12"><button class="btn btn-primary" @click="addOrder">Save</button></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="ibox float-e-margins">
      <div class="ibox-title">
        <h5>Site Grader</h5>
        <div class="ibox-tools">
          <button class="btn btn-primary btn-xs" @click="showModal('modal-order')">Add Order</button>
        </div>
      </div>
      <div class="ibox-content table-responsive col-lg-12">
        <div class="row" v-if="user.admin">
          <div class="col-lg-3 m-b-sm">
            <label for="showAll">Show all orders:</label>
            <input type="checkbox" name="all" id="showAll" v-model="showAll" @change="getOrders">
          </div>
        </div>
        <table class="table table-striped table-bordered table-hover dataTables-example" v-if="orders">
          <thead>
          <tr>
            <th>Order</th>
            <th>User</th>
            <th>Client</th>
            <th>Remote Id</th>
            <th>Time Started</th>
            <th class="col-lg-1">Urls</th>
            <th class="col-lg-1">
              Actions
              <i class="fa fa-refresh pull-right pointer" @click="getOrders"></i>
            </th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="order in orders" :key="order.id">
            <td>
              <i class="fa fa-play blue" title="Processing" v-if="order.status === 'processing'" />
              <i class="fa fa-clock orange" title="Added" v-if="order.status === 'added'" />
              <i class="fa fa-check green" title="Completed" v-if="order.status === 'completed'" />
              {{ order.id }}
            </td>
            <td class="center">{{ order.user ? order.user.username : '/' }}</td>
            <td class="center">{{ order.client || '/' }}</td>
            <td class="center">{{ order.remoteId }}</td>
            <td>{{ $moment(order.startTime.date).format('DD.MM.Y HH:mm') }}</td>
            <td class="center"><span v-if="order.status !== 'completed'">{{ order.resultsStatus.completed }} / </span>{{ order.payload.length }}</td>
            <td>
              <a
                v-if="order.status === 'completed'"
                download
                :href="'https://toolbox.aphex.me/toolbox/seo/site-grader/order/' + order.id + '/results?type=csv'"><i class="fa fa-download"></i></a>
            </td>
          </tr>
          </tbody>
          <tfoot>
          <tr>
            <th>Order</th>
            <th>User</th>
            <th>Client</th>
            <th>Remote Id</th>
            <th>Time Started</th>
            <th class="col-lg-1">Urls</th>
            <th class="col-lg-1">Actions</th>
          </tr>
          </tfoot>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
export default {
  name: 'IndexChecker',
  data () {
    return {
      add: {
        remoteId: '',
        urls: ''
      },
      user: this.$store.state.user,
      showAll: false,
      orders: []
    }
  },
  mounted () {
    this.getOrders()
  },
  methods: {
    getOrders () {
      axios.get('/toolbox/seo/site-grader/orders?users=' + (this.showAll === true ? 'all' : 'me'))
        .then(r => {
          this.orders = r.data.data
        })
        .catch(e => {
          this.$toastr.error(e, 'With great sadness...')
        })
    },
    addOrder () {
      if (this.add.remoteId.length < 3) {
        this.$toastr.error('id needs to be at least 3 chars long and unique, so try a bit harder', 'Omg...')
        return
      }

      let urls = []
      this.add.urls.split('\n').forEach(url => {
        urls.push(url)
      })

      if (urls.length < 2) {
        this.$toastr.error('Please provide some urls...', 'Slacker')
        return
      }

      axios.post('/toolbox/seo/site-grader', {
        remoteId: this.add.remoteId,
        payload: urls
      })
        .then(r => {
          this.hideModal('modal-order')
          this.add.remoteId = ''
          this.add.urls = ''
          this.getOrders()
        })
        .catch(e => {
          this.$toastr.error(e.msg)
        })
    },
    showModal (id) {
      $('#' + id).modal('show')
    },
    hideModal (id) {
      $('#' + id).modal('hide')
    }
  }
}
</script>
<style>
  .center {
    text-align: center;
  }
  .green {
    color: green;
  }
  .blue {
    color: #0c73b8;
  }
  .orange {
    color: orange;
  }
  .pointer {
    cursor: pointer;
  }
</style>



// WEBPACK FOOTER //
// src/components/Pages/Std/HaxSiteGrader.vue